import { linkResolver } from '../../../linkResolver'
import Link from 'next/link'
import { PrismicProvider } from '@prismicio/react'
import { ReactFC } from 'common/types/ReactFC'
import PrismicScript from 'components/util/PrismicScript' // we need this to make JSX compile

type PrismicContainerType = {}

const PrismicContainer: ReactFC<PrismicContainerType> = ({ children }) => {
  return (
    <PrismicProvider
      linkResolver={linkResolver}
      internalLinkComponent={({ children, href, ...props }) => (
        <Link href={href}>{children}</Link>
      )}
    >
      {/* eslint-disable-next-line react/jsx-no-undef */}
      <PrismicScript>{children}</PrismicScript>
    </PrismicProvider>
  )
}

export default PrismicContainer
